<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <org-unit-historical-invoices :teamId="props.teamId" :orgUnitId="props.orgUnitId" />
    </org-unit-details>
</template>

<script setup>
import OrgUnitHistoricalInvoices from '~/components/settings/billing/OrgUnitHistoricalInvoices.vue';
import OrgUnitDetails from '../form/OrgUnitDetails.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
});
</script>
